<template>
  <div class="race-guessing">
    <div class="modelTitle">· 赛事竞猜 ·</div>
    <div class="content">
      <div class="swiper-box">
        <div
          class="list-swiper"
          v-for="(item, index) in swiperList"
          :key="index"
          :class="{ anim: animate && index == 0 }"
        >
          <img :src="item.headImg" alt="" />
          <div class="name">{{ item.nickName }}</div>
          <div class="guessing">
            预测【{{ item.eventTag }} {{ gueResult(item) }}】
          </div>
        </div>
      </div>
      <div class="competition">
        <div class="title-left">
          <div class="dian"></div>
          <div class="title">过往赛事...</div>
        </div>
        <div class="title-right" @click="pastEvents()">
          查看
          <img
            src="https://assets.rurushishi.com/activies/football/down.png"
            alt=""
          />
        </div>
      </div>
      <div
        class="game"
        v-for="(item, index) in newCompetitionList"
        :key="index"
      >
        <div v-if="item.status == 1">
          <div class="competition">
            <div class="title-left">
              <div class="dian"></div>
              <div class="title">
                {{ getTimeData(item.contestTime) }} {{ item.eventTag }}
              </div>
            </div>
            <div
              class="title-right-tz"
              v-if="item.prizeAnnouncement"
              style="opacity: 0.6"
            >
              <img
                src="https://assets.rurushishi.com/activies/football/tixing.png"
                alt=""
              />
              <span>已订阅</span>
            </div>
            <div
              class="title-right-tz"
              v-if="'guessOption' in item && !item.prizeAnnouncement"
              @click="runLottery(item.id)"
            >
              <img
                src="https://assets.rurushishi.com/activies/football/tixing.png"
                alt=""
              />

              <span>开奖通知</span>
            </div>
          </div>
          <div class="saishi">
            <div class="time-box">
              <div class="time-left">
                {{ item.contestTime.substring(10, 16) }}
              </div>
              <div
                v-if="!('guessOption' in item) && !item.type"
                class="time-right"
              >
                <span>竞猜剩余时间</span
                ><span>{{
                  residueTime(item.beginGuessTime, item.endGuessTime)
                }}</span>
              </div>
              <div
                v-if="!('guessOption' in item) && item.type"
                class="time-right"
              >
                <span>竞猜已截止</span>
              </div>
            </div>
            <div class="pk-bg">
              <div class="gj-l dingw">{{ item.homeTeamName }}</div>
              <div class="gj-r dingw">{{ item.awayTeamName }}</div>
              <div class="jl-jf">本场奖励{{ item.point }}澳朵金豆</div>
              <div class="zhudui">
                <img :src="item.homeTeamFlag" alt="" />
              </div>
              <div class="kedui">
                <img :src="item.awayTeamFlag" alt="" />
              </div>
            </div>
            <div class="yazhu">
              <!-- :style="{opacity:item.guessOption !== 1?0.4:1}" -->
              <div
                class="yz-l"
                :class="{
                  opacity1: item.guessOption !== 1 && 'guessOption' in item,
                }"
                @click="guessSelect(1, item)"
              >
                <div class="result">胜利</div>
                <div class="probability">{{ item.homeWinGuessRate }}%支持</div>
              </div>
              <!--  :style="{opacity:item.guessOption !== 0?0.4:1}" -->
              <!-- <div
                class="yz-c"
                :class="{
                  opacity1: item.guessOption !== 0 && 'guessOption' in item,
                }"
                @click="guessSelect(0, item)"
              >
                <div class="result">平局</div>
                <div class="probability">{{ item.drawGuessRate }}%支持</div>
              </div> -->
              <div
                class="yz-c"
                :class="{
                  opacity1:true,
                }"
              >
                <div class="result">平局</div>
                <div class="probability">{{ item.drawGuessRate }}%支持</div>
              </div>
              <div
                class="yz-r"
                :class="{
                  opacity1: item.guessOption !== -1 && 'guessOption' in item,
                }"
                @click="guessSelect(-1, item)"
              >
                <div class="result">胜利</div>
                <div class="probability">{{ item.awayWinGuessRate }}%支持</div>
              </div>
              <div class="yjc" v-if="item.guessOption == 1">
                <img
                  src="https://assets.rurushishi.com/activies/football/yijincai.png"
                  alt=""
                />
              </div>
              <div class="yjc1" v-if="item.guessOption == 0">
                <img
                  src="https://assets.rurushishi.com/activies/football/yijincai.png"
                  alt=""
                />
              </div>
              <div class="yjc2" v-if="item.guessOption == -1">
                <img
                  src="https://assets.rurushishi.com/activies/football/yijincai.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
        <div v-if="item.status == 2">
          <div class="competition">
            <div class="title-left">
              <div class="dian"></div>
              <div class="title">
                {{ getTimeData(item.contestTime) }} {{ item.eventTag }}
              </div>
            </div>
            <div
              class="title-right-tz"
              v-if="item.prizeAnnouncement"
              style="opacity: 0.6"
            >
              <img
                src="https://assets.rurushishi.com/activies/football/tixing.png"
                alt=""
              />
              <span>已订阅</span>
            </div>
            <div
              class="title-right-tz"
              v-if="'guessOption' in item && !item.prizeAnnouncement"
              @click="runLottery(item.id)"
            >
              <img
                src="https://assets.rurushishi.com/activies/football/tixing.png"
                alt=""
              />

              <span>开奖通知</span>
            </div>
          </div>
          <div class="saishi">
            <div class="time-box">
              <div class="time-left">
                {{ item.contestTime.substring(10, 16) }}
              </div>
              <div class="time-right">
                <span style="color: #000">竞猜已截止</span>
              </div>
            </div>
            <div class="pk-bg">
              <div class="gj-l dingw">{{ item.homeTeamName }}</div>
              <div class="gj-r dingw">{{ item.awayTeamName }}</div>
              <div class="jl-jf">本场奖励{{ item.point }}澳朵金豆</div>
              <div class="zhudui">
                <img :src="item.homeTeamFlag" alt="" />
              </div>
              <div class="kedui">
                <img :src="item.awayTeamFlag" alt="" />
              </div>
            </div>
            <div class="yazhu">
              <div
                class="yz-l"
                :class="{
                  opacity1: item.guessOption !== 1 && 'guessOption' in item,
                }"
              >
                <div class="result">胜利</div>
                <div class="probability">{{ item.homeWinGuessRate }}%支持</div>
              </div>
              <!-- <div
                class="yz-c"
                :class="{
                  opacity1: item.guessOption !== 0 && 'guessOption' in item,
                }"
              >
                <div class="result">平局</div>
                <div class="probability">{{ item.drawGuessRate }}%支持</div>
              </div> -->
              <div
                class="yz-c"
                :class="{
                  opacity1: true,
                }"
              >
                <div class="result">平局</div>
                <div class="probability">{{ item.drawGuessRate }}%支持</div>
              </div>
              <div
                class="yz-r"
                :class="{
                  opacity1: item.guessOption !== -1 && 'guessOption' in item,
                }"
              >
                <div class="result">胜利</div>
                <div class="probability">{{ item.awayWinGuessRate }}%支持</div>
              </div>
              <div class="yjc" v-if="item.guessOption == 1">
                <img
                  src="https://assets.rurushishi.com/activies/football/yijincai.png"
                  alt=""
                />
              </div>
              <div class="yjc1" v-if="item.guessOption == 0">
                <img
                  src="https://assets.rurushishi.com/activies/football/yijincai.png"
                  alt=""
                />
              </div>
              <div class="yjc2" v-if="item.guessOption == -1">
                <img
                  src="https://assets.rurushishi.com/activies/football/yijincai.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
        <div v-if="item.status == 4">
          <div class="competition">
            <div class="title-left">
              <div class="dian"></div>
              <div class="title">
                {{ getTimeData(item.contestTime) }} {{ item.eventTag }}
              </div>
            </div>
            <div
              class="title-right-tz"
              v-if="item.prizeAnnouncement"
              style="opacity: 0.6"
            >
              <img
                src="https://assets.rurushishi.com/activies/football/tixing.png"
                alt=""
              />
              <span>已订阅</span>
            </div>
            <div
              class="title-right-tz"
              v-if="'guessOption' in item && !item.prizeAnnouncement"
              @click="runLottery(item.id)"
            >
              <img
                src="https://assets.rurushishi.com/activies/football/tixing.png"
                alt=""
              />

              <span>开奖通知</span>
            </div>
          </div>
          <div class="saishi">
            <div class="time-box">
              <div class="time-left">
                {{ item.contestTime.substring(10, 16) }}
              </div>
              <div class="time-right">
                <span style="color: #000">竞猜已截止</span>
              </div>
            </div>
            <div class="pk-bg">
              <div class="gj-l dingw">{{ item.homeTeamName }}</div>
              <div class="gj-r dingw">{{ item.awayTeamName }}</div>
              <div class="jl-jf">本场奖励{{ item.point }}澳朵金豆</div>
              <div class="zhudui">
                <img :src="item.homeTeamFlag" alt="" />
              </div>
              <div class="kedui">
                <img :src="item.awayTeamFlag" alt="" />
              </div>
            </div>
            <div class="yazhu">
              <div class="yz-l" :class="{ opacity1: true }">
                <div class="result">胜利</div>
                <div class="probability">{{ item.homeWinGuessRate }}%支持</div>
              </div>
              <div class="yz-c" :class="{ opacity1: true }">
                <div class="result">平局</div>
                <div class="probability">{{ item.drawGuessRate }}%支持</div>
              </div>
              <div class="yz-r" :class="{ opacity1: true }">
                <div class="result">胜利</div>
                <div class="probability">{{ item.awayWinGuessRate }}%支持</div>
              </div>
              <div class="yjc" v-if="item.guessOption == 1">
                <img
                  src="https://assets.rurushishi.com/activies/football/yijincai.png"
                  alt=""
                />
              </div>
              <div class="yjc1" v-if="item.guessOption == 0">
                <img
                  src="https://assets.rurushishi.com/activies/football/yijincai.png"
                  alt=""
                />
              </div>
              <div class="yjc2" v-if="item.guessOption == -1">
                <img
                  src="https://assets.rurushishi.com/activies/football/yijincai.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
        <div class="game-wks" v-if="item.status == 3">
          <div class="competition">
            <div class="title-left">
              <div class="dian"></div>
              <div class="title">
                {{ getTimeData(item.contestTime) }} {{ item.eventTag }}
              </div>
            </div>
            <!-- @click="showTixing()" -->
            <div class="title-right-tz">
              <img
                src="https://assets.rurushishi.com/activies/football/tixing.png"
                alt=""
              />
              <span v-if="item.matchReminder" style="opacity: 0.6">已订阅</span
              ><span v-else @click="getSession(item.id)">赛事提醒</span>
            </div>
          </div>
          <div class="game schedule">
            <div class="game-item">
              <div class="item-l">
                <div class="nation">
                  <div class="nation-l">
                    <img :src="item.homeTeamFlag || toimgUrl" alt="" />
                    <span>{{ item.homeTeamName }}</span>
                  </div>
                  <div class="nation-l">
                    <img :src="item.awayTeamFlag || toimgUrl" alt="" />
                    <span>{{ item.awayTeamName }}</span>
                  </div>
                </div>
                <div class="score">
                  <div style="text-align: right"><span>--</span></div>
                  <div><span></span></div>
                  <div style="text-align: right"><span>--</span></div>
                </div>
              </div>
              <div class="item-r">
                <div class="time">{{ item.contestTime.substring(10, 16) }}</div>
                <div>本场奖励</div>
                <div>{{ item.point }}澳朵金豆</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="competition">
        <div class="title-left">
          <div class="dian"></div>
          <div class="title">更多赛事</div>
        </div>
        <div class="title-right" @click="toMore()">
          查看
          <img
            src="https://assets.rurushishi.com/activies/football/down.png"
            alt=""
          />
        </div>
      </div>
    </div>
    <!-- 获取竞猜机会 -->
    <div class="mymodal" v-show="value">
      <div class="info">
        <div class="info-title"></div>
        <div class="fare">
          <div class="title-kj">{{ titleGues }}</div>
          <div class="content-wz">
            {{ txt }}
          </div>
          <div class="btn">呼朋唤友</div>
          <div class="botBtn" @click="closeTc('value')">
            <img
              src="http://assets.rurushishi.com/activies/panda-game/close.png"
              alt
            />
          </div>
        </div>
      </div>
    </div>
    <!-- 竞猜押注信息提示 -->
    <div class="mymodal" v-show="showActInfo">
      <div class="info">
        <div class="info-title"></div>
        <div class="fare">
          <div class="title-kj">{{ titleGues1 }}</div>
          <div class="content-wz" style="text-align: center">
            {{ txt1 }}
          </div>
          <div class="btn" @click="onSelect()">确定</div>
          <div class="botBtn" @click="closeTc('info')">
            <img
              src="http://assets.rurushishi.com/activies/panda-game/close.png"
              alt
            />
          </div>
        </div>
      </div>
    </div>
    <!-- 更多赛事 -->
    <div class="mymodal" v-show="oldCompetition" style="color: #000">
      <div class="info" style="padding: 0">
        <div class="info-title"></div>
        <div class="fare">
          <div class="title-kj">过往赛事</div>
          <div v-if="oldCompetitionList.length > 0" class="guess" style="height: 200px; overflow-y: auto">
            <div v-for="(item, index) in oldCompetitionList" :key="index">
              <div class="time-data">
                {{ item.contestTime.slice(5, 7) }}月{{
                  item.contestTime.slice(8, 10)
                }}日
              </div>
              <div class="game schedule">
                <div class="game-item">
                  <div class="item-l">
                    <div class="nation">
                      <div class="nation-l">
                        <img :src="item.homeTeamFlag" alt="" />
                        <span>{{ item.homeTeamName }}</span>
                      </div>
                      <div class="nation-l">
                        <img :src="item.awayTeamFlag" alt="" />
                        <span>{{ item.awayTeamName }}</span>
                      </div>
                    </div>
                    <div class="score">
                      <div class="victory">
                        <span v-if="item.homeScore == -1">-</span
                        ><span v-else>{{ item.homeScore }}</span
                        ><span
                          :style="{
                            opacity: item.awayScore < item.homeScore ? 1 : 0.2,
                          }"
                          >胜</span
                        >
                      </div>
                      <div class="flat">
                        <span></span
                        ><span
                          :style="{
                            opacity:
                              item.awayScore == item.homeScore &&
                              item.homeScore !== -1
                                ? 1
                                : 0.2,
                          }"
                          >平</span
                        >
                      </div>
                      <div class="fail">
                        <span v-if="item.homeScore == -1">-</span
                        ><span v-else>{{ item.awayScore }}</span
                        ><span
                          :style="{
                            opacity: item.awayScore > item.homeScore ? 1 : 0.2,
                          }"
                          >胜</span
                        >
                      </div>
                    </div>
                  </div>
                  <div class="item-r">
                    <div class="time">
                      {{ item.contestTime.substring(10, 16) }}
                    </div>
                    <div>本场奖励</div>
                    <div>{{ item.point }}澳朵金豆</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else class="no-data">
            暂无数据 ~
          </div>
          <div class="botBtn" @click="oldCompetition = false">
            <img
              src="http://assets.rurushishi.com/activies/panda-game/close.png"
              alt
            />
          </div>
        </div>
      </div>
    </div>
    <showRemind ref="showRemind" @fMethod="recentEvents"></showRemind>
    <showKaijiang ref="showKaijiang" @fMethod="recentEvents"></showKaijiang>
  </div>
</template>

<script>
import showRemind from "./showRemind.vue";
import showKaijiang from "./showKaijiang.vue";
export default {
  props: {
    drawsNum: {
      type: Number, //age的类型是Number
      default: 0, //age不是必须传入,如果不传默认99
    },
  },
  components: { showRemind, showKaijiang },
  data() {
    return {
      swiperList: [],
      pageNum: 1,
      pageNum1: 1,
      newCompetitionList: [],
      oldCompetitionList: [],
      animate: false, // 滚动奖品动画
      value: false,
      showActInfo: false,
      titleGues: "获取竞猜机会",
      txt: "你的竞猜机会已用完，邀请好友参与可获得更多竞猜机会哦~",
      titleGues1: "",
      txt1: "预测提交后将扣除一次竞猜机会",
      guestype: null,
      sessionId: null,
      oldCompetition: false,
      totalPage: 0,
      toimgUrl: "https://assets.rurushishi.com/activies/football/weizi.png",
      //   showRemind: false,
      //   showKaijiang: false,
    };
  },
  //   computed() {},
  created() {
    this.guessList();
    this.recentEvents();
    // this.pastEvents();
  },
  methods: {
    async guessList() {
      this.$httpdf.get(this.apiHost + "fc/guessList").then((data) => {
        // console.log(data, "33345");
        this.swiperList = data.data;
        setInterval(this.scroll, 2000);
      });
    },
    getSession(id) {
      sessionStorage.setItem("sessionId", id);
      //   this.$modal.RemindForm.alert();
      //   this.$ref.showRemind
      this.$refs.showRemind.getMask();
    },
    runLottery(id) {
      sessionStorage.setItem("sessionId", id);
      //   this.$modal.drawSuccess.alert();
      this.$refs.showKaijiang.getMask();
    },
    closeTc(type) {
      if (type == "value") {
        this.value = false;
      } else if (type == "info") {
        this.showActInfo = false;
      }
    },
    // 底部获奖列表滚动
    scroll() {
      this.animate = true;
      setTimeout(() => {
        this.swiperList.push(this.swiperList[0]);
        this.swiperList.shift();
        this.animate = false;
      }, 1000);
    },
    gueResult(item) {
      if (item.guessOption == 0) {
        return item.homeTeamName + "VS" + item.awayTeamName + "平";
      } else if (item.guessOption == 1) {
        return item.homeTeamName + "胜";
      } else if (item.guessOption == -1) {
        return item.awayTeamName + "胜";
      }
    },
    showTixing() {
      //   console.log("点击了");
      this.$modal.RemindForm.alert();
    },
    async toMore() {
      this.pageNum += 1;
      if (this.pageNum > this.totalPage) {
        console.log("没有更多了");
        return;
      }
      const data = await this.$httpdf.get(
        this.apiHost + "fc/recentEvents" + `?cur=${this.pageNum}&pageSize=10`
      );
      if (data.code == 0) {
        // console.log( this.$util.moment("2020-01-04 21:30:00"),'111')
        //2.判断开始时间是否大于当前时间,如果大于当前时间则显示倒计时；倒计时时间为结束时间减去开始时间 如果开始时间小于当前时间则显示空endGuessTime 结束时间
        let arrList = data.data.list;
        arrList.map((item) => {
          if (
            this.$util.moment().isAfter(item.beginGuessTime) &&
            this.$util.moment().isBefore(item.endGuessTime)
          ) {
            item.status = 1;
          } else if (
            this.$util.moment().isAfter(item.endGuessTime) &&
            item.hasOwnProperty("guessOption")
          ) {
            item.status = 2;
          } else if (
            this.$util.moment().isAfter(item.endGuessTime) &&
            !item.hasOwnProperty("guessOption")
          ) {
            item.status = 4;
          } else if (this.$util.moment().isBefore(item.beginGuessTime)) {
            item.status = 3;
          }
        });
        this.newCompetitionList = this.newCompetitionList.concat(arrList);
        // console.log(this.newCompetitionList, "++");
      }
    },
    //moment.js 判断日期 如果不为当天日期则显示日期2024-06-09如果为当天则显示今日
    getTimeData(item) {
      //   console.log(item, "+++_");
      if (this.$util.moment().isSame(item, "day")) {
        return "今日";
      } else {
        return item.slice(5, 10);
      }
    },
    //用户竞猜
    guessSelect(type, item) {
      if ("guessOption" in item) {
        return;
      }
      this.guestype = type;
      this.sessionId = item.id;
      if (this.drawsNum > 0) {
        this.showActInfo = true;
        if (type == 1) {
          this.titleGues1 = item.homeTeamName + "胜利";
        } else if (type == 0) {
          this.titleGues1 =
            item.homeTeamName + "VS" + item.awayTeamName + "平局";
        } else {
          this.titleGues1 = item.awayTeamName + "胜利";
        }
      } else {
        this.value = true;
      }
    },
    onSelect() {
      this.$httpdf
        .get(
          this.apiHost +
            "fc/guess" +
            "?sessionId=" +
            this.sessionId +
            "&option=" +
            this.guestype
        )
        .then((data) => {
          if (data.code == 0) {
            // console.log(data, "竞猜成功");
            this.showActInfo = false;
            this.recentEvents();
            //调用父组件方法
            this.$emit("onSelect");
          } else {
            this.$showModal(data.msg);
          }
        });
    },
    residueTime(beginGuessTime, endGuessTime) {
      //判断比赛是否已开始  当当前时间小于比赛时间则比赛未开始，大于比赛开始时间则比赛开始，大于结束时间则比赛结束
      if (this.$util.moment().isBefore(beginGuessTime)) {
        return "比赛未开始";
      } else if (this.$util.moment().isAfter(beginGuessTime)) {
        //比赛时间减去当前时间 显示HH:mm:ss
        let seconds = this.$util
          .moment(endGuessTime)
          .diff(this.$util.moment(), "seconds");
        let hh = parseInt(seconds / 3600);
        let mm = parseInt((seconds - hh * 3600) / 60);
        let ss = seconds - hh * 3600 - mm * 60;
        if (mm < 10) {
          mm = "0" + mm;
        }
        if (ss < 10) {
          ss = "0" + ss;
        }
        return hh + ":" + mm + ":" + ss;
      } else if (this.$util.moment().isAfter(endGuessTime)) {
        return "比赛已结束";
      }
    },
    //近期赛事
    async recentEvents() {
      this.pageNum = 1;
      const data = await this.$httpdf.get(
        this.apiHost + "fc/recentEvents" + `?cur=${this.pageNum}&pageSize=10`
      );
      if (data.code == 0) {
        // console.log( this.$util.moment("2020-01-04 21:30:00"),'111')
        //2.判断开始时间是否大于当前时间,如果大于当前时间则显示倒计时；倒计时时间为结束时间减去开始时间 如果开始时间小于当前时间则显示空endGuessTime 结束时间
        let arrList = data.data.list;
        arrList.map((item) => {
          // if ( this.$util.moment().isAfter(item.endGuessTime) &&
          //   this.$util.moment().isSame(item.endGuessTime, "day") &&
          //   item.guessStatus == 0) {
          //   item.status = 0;
          // } else
          if (
            this.$util.moment().isAfter(item.beginGuessTime) &&
            this.$util.moment().isBefore(item.endGuessTime)
          ) {
            item.status = 1;
          } else if (
            this.$util.moment().isAfter(item.endGuessTime) &&
            item.hasOwnProperty("guessOption")
          ) {
            item.status = 2;
          } else if (
            this.$util.moment().isAfter(item.endGuessTime) &&
            !item.hasOwnProperty("guessOption")
          ) {
            item.status = 4;
          } else if (this.$util.moment().isBefore(item.beginGuessTime)) {
            item.status = 3;
          }
        });
        this.newCompetitionList = arrList;
        this.totalPage = data.data.totalPage;
        console.log(this.newCompetitionList, "_______");
      }
    },
    //过往赛事
    async pastEvents() {
      this.oldCompetition = true;
      const data = await this.$httpdf.get(
        this.apiHost + "fc/pastEvents" + `?cur=${this.pageNum1}&pageSize=100`
      );
      if (data.code == 0) {
        this.oldCompetitionList = data.data.list;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
div {
  box-sizing: border-box;
}

.race-guessing {
  width: 351px;
  margin: 50px auto 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 12px;

  background-color: #36841b;
  box-sizing: border-box;

  .modelTitle {
    position: absolute;
    color: white;
    padding: 0 20px;
    line-height: 40px;
    height: 40px;
    text-align: center;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    display: inline-block;
    font-size: 20px;
    font-weight: 600;
    z-index: 1;
    background-color: #58a72a;
  }

  .content {
    width: 100%;
    padding: 60px 10px 0;

    .swiper-box {
      height: 38px;
      width: 100%;
      background-color: #fff;
      border-radius: 19px;
      font-size: 12px;
      overflow: hidden;
      background: #265b14;
      margin-bottom: 15px;
      .list-swiper {
        display: flex;
        align-items: center;
        height: 100%;
        width: 100%;
        padding: 0 10px;
        color: #fff;
        img {
          width: 28px;
          height: 28px;
          border-radius: 16px;
          margin: 0 10px;
        }
      }
      .anim {
        transition: all 1s;
        margin-top: -38px;
      }
    }

    .competition {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-bottom: 12px;

      .title-left {
        display: flex;
        align-items: center;
        padding-left: 10px;

        .dian {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          margin-right: 10px;
          background-color: #fff;
        }

        .title {
          font-size: 14px;
          color: #fff;
        }
      }

      .title-right {
        width: 66px;
        height: 24px;
        text-align: center;
        line-height: 24px;
        color: #fff;
        font-size: 12px;
        border: 1px solid #fff;
        border-radius: 12px;

        img {
          width: 12px;
          height: 12px;
        }
      }

      .title-right-tz {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 88px;
        height: 24px;
        text-align: center;
        line-height: 24px;
        color: #fff;
        font-size: 12px;
        border-radius: 12px;
        background-color: #4a952d;

        img {
          margin-right: 5px;
          width: 12px;
          height: 12px;
        }
      }
    }

    .game {
      //   padding: 10px 12px;

      //   background-color: #ebf3e8;
      margin-bottom: 12px;
      .saishi {
        width: 100%;
        padding: 10px 12px;
        border-radius: 8px;
        background-color: #ebf3e8;
        margin-bottom: 12px;
      }

      .time-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;

        .time-left {
          font-size: 18px;
          font-weight: 700;
        }

        .time-right {
          font-size: 14px;

          span:last-child {
            margin-left: 5px;
            color: #51a3e8;
          }
        }
      }

      .pk-bg {
        position: relative;
        width: 100%;
        height: 128px;
        background: url("https://assets.rurushishi.com/activies/football/pk.png")
          no-repeat center center;
        background-size: 100% 100%;
        margin-bottom: 22px;

        .dingw {
          position: absolute;
          top: 80px;
          color: #fff;
          font-size: 16px;
          text-shadow: 2px 2px 2px #666;
        }

        .gj-l {
          left: 88px;
          transform: translate(-50%);
        }

        .gj-r {
          width: 120px;
          text-align: center;
          left: 224px;
          transform: translate(-50%);
        }

        .jl-jf {
          position: absolute;
          bottom: 7px;
          left: 50%;
          transform: translateX(-50%);
          color: #9e6123;
          font-size: 12px;
        }
        .zhudui {
          position: absolute;
          top: 5px;
          left: 29%;
          transform: translateX(-50%);
          width: 60px;
          height: 60px;
          overflow: hidden;
          border-radius: 30px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .kedui {
          position: absolute;
          top: 5px;
          left: 72.5%;
          transform: translateX(-50%);
          width: 60px;
          height: 60px;
          overflow: hidden;
          border-radius: 30px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }

      .yazhu {
        position: relative;
        width: 100%;
        height: 60px;
        color: #fff;
        display: flex;

        .yz-l {
          width: 108px;
          height: 100%;
          background: url("https://assets.rurushishi.com/activies/football/shengli-left.png");
          background-size: 100% 100%;
        }

        .yz-c {
          width: 108px;
          height: 100%;
          background: url("https://assets.rurushishi.com/activies/football/pingju.png");
          background-size: 100% 100%;
        }

        .yz-r {
          width: 108px;
          height: 100%;
          background: url("https://assets.rurushishi.com/activies/football/shengli-rigth.png");
          background-size: 100% 100%;
        }
        .opacity1 {
          opacity: 0.4;
        }
        .yjc {
          position: absolute;
          top: -18px;
          left: 27px;
          width: 55px;
          height: 30px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .yjc1 {
          position: absolute;
          top: -18px;
          left: 127px;
          width: 55px;
          height: 30px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .yjc2 {
          position: absolute;
          top: -18px;
          left: 227px;
          width: 55px;
          height: 30px;
          img {
            width: 100%;
            height: 100%;
          }
        }

        .result {
          font-size: 16px;
          line-height: 30px;
          text-align: center;
        }

        .probability {
          font-size: 12px;
          text-align: center;
          line-height: 15px;
        }
      }
    }
    .game-wks {
      // width: 100%;
      // padding: 10px 12px;
      // border-radius: 8px;
      // background-color: #ebf3e8;
      // margin-bottom: 20px;
    }

    .schedule {
      width: 100%;
      padding: 10px 12px;
      border-radius: 8px;
      background-color: #ebf3e8;
      .game-item {
        display: flex;
        width: 100%;
        height: 90px;
        padding: 10px 0;

        .item-l {
          display: flex;
          align-items: center;
          width: 210px;
          height: 100%;

          .nation {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: 150px;
            height: 100%;

            .nation-l {
              font-size: 14px;

              img {
                width: 30px;
                height: 30px;
                margin-right: 10px;
                border-radius: 15px;
              }
            }
          }

          .score {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: 40px;
            height: 100%;
            padding: 5px 0;
            font-size: 14px;
          }

          .victory {
            display: flex;
            align-items: center;
            justify-content: right;

            span:last-child {
              font-size: 12px;
              background-color: #428fec;
              padding: 2px;
              border-radius: 4px;
              color: #fff;
              margin-left: 6px;
            }
          }

          .flat {
            display: flex;
            align-items: center;
            justify-content: right;

            span:last-child {
              background-color: #59a82a;
              font-size: 12px;
              padding: 2px;
              border-radius: 4px;
              color: #fff;
              margin-left: 6px;
            }
          }

          .fail {
            display: flex;
            align-items: center;
            justify-content: right;
            font-size: 12px;

            span:last-child {
              background-color: #ef4b57;
              padding: 2px;
              border-radius: 4px;
              color: #fff;
              margin-left: 6px;
            }
          }
        }

        .item-r {
          flex: 1;
          text-align: center;
          margin-left: 20px;
          border-left: 1px solid #cde4c2;

          .time {
            font-size: 15px;
            padding-top: 3px;
            line-height: 25px;
          }

          div {
            font-size: 12px;
            line-height: 18px;
          }
        }
      }

      .game-item:not(:last-child) {
        border-bottom: 1px solid #cde4c2;
      }
    }
  }
}

.mymodal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index: 100;
}

.info {
  width: 265px;
  background: #fff;
  border-radius: 10px;
  padding: 0 20px 20px;
  box-sizing: border-box;
  position: relative;
  .info-title {
    width: 265px;
    height: 106px;
    position: absolute;
    left: 50%;
    top: -100px;
    background: url($imgHost + "tanc.png") center / 100% no-repeat;
    transform: translateX(-50%);
  }
  .fare {
    font-size: 15px;
    font-family: PingFangSC;
    font-weight: 400;
    .schedule {
      width: 100%;
      padding: 0px 12px;
      border-radius: 8px;
      //   background-color: #ebf3e8;
      .game-item {
        display: flex;
        width: 100%;
        height: 80px;
        padding: 10px 0;

        .item-l {
          display: flex;
          align-items: center;
          width: 150px;
          height: 100%;

          .nation {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: 150px;
            height: 100%;

            .nation-l {
              font-size: 12px;

              img {
                width: 24px;
                height: 24px;
                margin-right: 10px;
                border-radius: 12px;
              }
            }
          }

          .score {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: 60px;
            height: 100%;
            padding: 5px 0;
            font-size: 12px;
          }

          .victory {
            display: flex;
            align-items: center;
            justify-content: right;

            span:last-child {
              font-size: 10px;
              background-color: #428fec;
              padding: 2px;
              border-radius: 4px;
              color: #fff;
              margin-left: 6px;
            }
          }

          .flat {
            display: flex;
            align-items: center;
            justify-content: right;

            span:last-child {
              background-color: #59a82a;
              font-size: 10px;
              padding: 2px;
              border-radius: 4px;
              color: #fff;
              margin-left: 6px;
            }
          }

          .fail {
            display: flex;
            align-items: center;
            justify-content: right;
            font-size: 10px;

            span:last-child {
              background-color: #ef4b57;
              padding: 2px;
              border-radius: 4px;
              color: #fff;
              margin-left: 6px;
            }
          }
        }

        .item-r {
          flex: 1;
          text-align: center;
          margin-left: 20px;
          border-left: 1px solid #cde4c2;

          .time {
            font-size: 12px;
            padding-top: 3px;
            line-height: 22px;
          }

          div {
            font-size: 10px;
            line-height: 16px;
          }
        }
      }

      .game-item:not(:last-child) {
        border-bottom: 1px solid #cde4c2;
      }
    }
    .title-kj {
      padding: 15px 0;
      text-align: center;
      font-size: 18px;
      color: #000;
    }
    .content-wz {
      font-size: 12px;
      color: #666666;
      line-height: 18px;
      margin-bottom: 10px;
    }
    .input_txt {
      margin-bottom: 10px;
    }
    .input_txt,
    .input_code {
      input {
        background-color: #f6f6f9;
        width: 100%;
        height: 28px;
      }
    }
    .input_code {
      display: flex;
      margin-bottom: 10px;
      .right {
        width: 90px;
        border: 1px solid #36841b;
        margin-left: 10px;
        color: #36841b;
        text-align: center;
        line-height: 28px;
        border-radius: 5px;
        // line-height: 60px;
      }
      .left {
        flex: 1;
      }
    }
  }
  .btn {
    width: 100%;
    height: 44px;
    border-radius: 22px;
    text-align: center;
    line-height: 44px;
    background-color: #fdb43a;
  }
  .botBtn {
    position: absolute;
    left: 50%;
    top: 110%;
    transform: translateX(-50%);
    // width: 140px;
    // height: 39px;
    // line-height: 39px;
    // background: #6488f7;
    // border-radius: 20px;
    // font-size: 18px;
    // font-family: PingFangSC;
    // font-weight: 500;
    // color: #ffffff;
    // text-align: center;
    width: 20px;
    height: 20px;
  }
}

.time-data {
  width: 100%;
  background-color: #f3f3f3;
  font-size: 14px;
  line-height: 30px;

  padding-left: 10px;
}

.no-data {
  background: #fff;
  height: 150px;
  width: 100%;
  line-height: 120px;
  text-align: center;
  border-radius: 12px;
}
</style>
